import React, { Component } from 'react';
import Login from './Components/Login'
import Wallet from './Components/Wallet'
import Consent from './Components/Consent'
import {AmazonJS} from './AmazonJS'
import './styles.scss'

class Amazon extends Component {

  state = {
    current: 'login'
  }

  async componentDidMount() {
    await AmazonJS();
    
    const { clientId } = window.settings.paymentProviders.amazon
    window.amazon.Login.setClientId('amzn1.application-oa2-client.' + clientId);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.current !== this.state.current && this.state.current !== 'login') {
      this.props.overlay({ styles: { backgroundColor: '#a9a9a5b0' } })
    }
  }

  renderWidgets() {
    // TODO: replace platformId by sellerId once fixed in tools
    const { platformId } = window.settings.paymentProviders.amazon
    switch(this.state.current) {
      case 'wallet':
        return (
          <Wallet 
            displayConsent={(b) => this.setState({ current: 'consent', billingAgreement: b })}
            sellerId={platformId}
            agreementType='BillingAgreement'
          />
        )
      case 'consent':
        return (
          <Consent 
            billingAgreement={this.state.billingAgreement} 
            sellerId={platformId} 
            subscribe={this.props.subscribe}
          />
        )
      default:
        return (
          <Login 
            displayWallet={() => this.setState({ current: 'wallet' })}
            sellerId={platformId}
            buttonId='AmazonPayButton'
            disabled={this.props.disabled}
          />  
        )
    }
  }

  render() {
    return (
      <div className="amazon-pay">
        { this.renderWidgets() }
      </div>
    )
  }
}

export default Amazon;